import { render } from "./googleGeneral.vue?vue&type=template&id=6b02bd40"
import script from "./googleGeneral.vue?vue&type=script&lang=js"
export * from "./googleGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__